var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsxs, jsx } from "react/jsx-runtime";
import "../Checkbox/index.js";
import { Field } from "./Field.js";
import "../ValidationError/index.js";
import { Checkbox } from "../Checkbox/Checkbox.js";
import { ValidationError } from "../ValidationError/ValidationError.js";
class CheckboxField extends Field {
  constructor() {
    super(...arguments);
    __publicField(this, "children", (fieldProps) => {
      const { meta, field } = fieldProps;
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(
          Checkbox,
          __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, this.props), {
            checked: !!this.props.disableFormikValueChecked ? this.props.checked : field.value
          }), field), {
            onChange: (ev, checked) => this._handleChange(fieldProps, ev, checked)
          })
        ),
        !!meta.touched && !!meta.error && /* @__PURE__ */ jsx(ValidationError, { children: meta.error })
      ] });
    });
    __publicField(this, "_handleChange", (props, ev, checked) => {
      props.form.setFieldValue(props.field.name, checked, true);
      this.props.onChange && this.props.onChange(ev, checked);
    });
  }
}
export {
  CheckboxField
};
//# sourceMappingURL=CheckboxField.js.map
